export default __webpack_public_path__ + "static/media/ed6.91b8ea9e.jpg";